interface FAQCardProps {
  question: string;
  answer: string;
}

export default function FAQCard({ question, answer }: FAQCardProps) {
  return (
    <div className="flex flex-col items-start gap-6 md:gap-8 flex-1 p-5 md:p-6 border border-gray-200 bg-tertiary">
      <h3 className="text-secondary font-semibold text-lg md:text-xl leading-[150%] w-full">
        {question}
      </h3>
      <p className="text-secondary font-medium text-sm md:text-base leading-[150%] w-full">
        {answer}
      </p>
      <button className="flex px-5 py-3 items-center gap-2.5 border border-gray-200 bg-gray-50 text-secondary font-medium text-sm md:text-base leading-[150%] hover:bg-gray-100 transition-colors">
        <span>Read More</span>
      </button>
    </div>
  );
}


